<template>
    <div>
        <div class="container-fluid featured-page-image">
            <div class="feature-header-page">
                <h1>About us</h1>
            </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-sm-12 intro mb-3">
              <h2>Spectrum Digital Labels</h2>
              <hr>
              <p>
                We are a UK based label printer who offer our customers a quality product with excellent service.
              </p>
              <p>
                We offer digital inkjet print using our latest high specification digital inkjet label press.
                This new technology supports quality products giving our customers a superior product in look, feel, quality and price.
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-7 col-lg-6 order-2 order-lg-1">
              <p>Our aims are to:</p>
              <ul>
                <li>Offer a professional and exemplary service to our customers.</li>
                <li>Offer a fast turnaround service to ensure our client’s delivery needs are met.</li>
                <li>Offer excellence in everything we do.</li>
                <li>Always do what we say we will do.</li>
                <li>Create a work environment where each person is valued and respected.</li>
                <li>Continue to build on our business to maintain and develop our position in the marketplace.</li>
              </ul>
            </div>

            <div class="col-xl-5 col-lg-6 order-1 order-lg-2 mb-4">
                <img alt="Scotch whisky labels"  src="@/assets/images/print_label_scotch.jpg" class="w-100"/>
            </div>

            <div class="col-12 order-3">
              <p>
                We achieve our aims and objectives by:
              </p>
              <ul>
                <li>Empowering our employees by recognising that every employee can contribute to improving our business performance and aim to fulfil their own potential through company provided training and experience.</li>
                <li>Continuous improvement in quality of our products, services and processes.</li>
                <li>Expanding our customer base, increased productivity and efficiency in our operations through training and investment in technology.</li>
                <li>Ensuring the health, safety and welfare of all our employees by providing the resources necessary to safeguard the working environment to prevent injury and ill health.</li>
              </ul>
            </div>

            <div class="col-12 order-4">
              <p>
                We will use our management review process to ensure that our progress, drive for improvement and our business objectives are monitored and reviewed.
              </p>
              <p>
                This policy will be communicated to all employees and those working on behalf of the business.
                It will be made publicly available and subject to regular review to ensure that it continues to meet the needs of our business, our customers and our wider social responsibilities.
              </p>
              <p class="font-italic">
                Managing Director – Joe Preddy
              </p>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-xl-4 col-lg-4 col-sm-6 mb-4">
              <img alt="IPA beer labels" src="@/assets/images/print_label_ipa.jpg" class="w-100"/>
            </div>
            <div class="col-xl-4 col-lg-4 col-sm-6 mb-4">
              <img alt="Whey protein labels"  src="@/assets/images/print_label_whey_protein.jpg" class="w-100"/>
            </div>
            <div class="col-xl-4 col-lg-4 col-sm-12 mb-4">
              <img alt="Wine labels"  src="@/assets/images/print_label_wine.jpg" class="w-100"/>
            </div>
          </div>
        </div>
      <action-panel></action-panel>
    </div>
</template>
<script>
import ActionPanel from '@/components/partials/ActionPanel'

export default {
  name: 'AboutUs',
  components: {ActionPanel}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue